(function () {
  function isAppleEnv() {
    const ua = navigator.userAgent || '';
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|Edg|OPR|SamsungBrowser|Firefox/i.test(ua);
    const isInstagram = /Instagram/i.test(ua);
    return isIOS || isSafari || isInstagram;
  }

  function getBlock() {
    return document.querySelector('.accelerated-checkout-block');
  }

  function hasRealAppleDom(block) {
    if (!block) return false;

    return !!(
      block.querySelector('shopify-apple-pay-button') ||
      block.querySelector('[slot*="ApplePay"]') ||
      block.querySelector('[aria-label*="Apple Pay"]') ||
      block.querySelector('[title*="Apple Pay"]') ||
      block.querySelector('[class*="apple-pay"]') ||
      block.querySelector('[id*="apple-pay"]')
    );
  }

  function setWalletView() {
    const block = getBlock();
    if (!block) return;

    const fake = block.querySelector('.lb-pdp-wallet-fake');
    if (!fake) return;

    fake.classList.remove('lb-pdp-wallet-fake--apple', 'lb-pdp-wallet-fake--shop');

    if (isAppleEnv()) {
      block.setAttribute('data-wallet-env', 'apple');
      fake.classList.add('lb-pdp-wallet-fake--apple');
      fake.textContent = 'Apple Pay';
    } else {
      block.setAttribute('data-wallet-env', 'shop');
      fake.classList.add('lb-pdp-wallet-fake--shop');
      fake.textContent = 'Shop Pay';
    }
  }

  function updateRealAppleState() {
    const block = getBlock();
    if (!block) return;

    const realApple = hasRealAppleDom(block);
    block.setAttribute('data-has-real-apple', realApple ? 'true' : 'false');
  }

  function bindSizeSelection() {
    const block = getBlock();
    if (!block) return;

    setWalletView();
    updateRealAppleState();

    const selectors = [
      'variant-radios input[type="radio"]',
      'variant-selects select',
      'input[type="radio"][name*="Size"]',
      'input[type="radio"][name*="option"]',
      'select[name*="option"]'
    ];

    const inputs = document.querySelectorAll(selectors.join(','));

    if (isAppleEnv()) {
      block.setAttribute('data-size-selected', 'true');
      setTimeout(updateRealAppleState, 300);
      setTimeout(updateRealAppleState, 900);
      setTimeout(updateRealAppleState, 1600);
      return;
    }

    if (!inputs.length) {
      block.setAttribute('data-size-selected', 'true');
      setTimeout(updateRealAppleState, 300);
      return;
    }

    block.setAttribute('data-size-selected', 'false');

    const activate = () => {
      block.setAttribute('data-size-selected', 'true');
      setWalletView();
      setTimeout(updateRealAppleState, 300);
      setTimeout(updateRealAppleState, 900);
      setTimeout(updateRealAppleState, 1600);
    };

    inputs.forEach((input) => {
      if (input.dataset.lbAppleBound === 'true') return;
      input.dataset.lbAppleBound = 'true';
      input.addEventListener('change', activate);
      input.addEventListener('click', activate);
    });
  }

  async function addCurrentProductToCart() {
    const productForm =
      document.querySelector('product-form-component form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!productForm) return false;

    const formData = new FormData(productForm);
    const variantId = formData.get('id');

    if (!variantId) return false;

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'application/json'
      },
      credentials: 'same-origin'
    });

    return response.ok;
  }

  function bindAppleDrawerOpen() {
    const trigger = document.querySelector('[data-lb-apple-drawer-open]');
    if (!trigger || trigger.dataset.lbDrawerBound === 'true') return;

    trigger.dataset.lbDrawerBound = 'true';

    trigger.addEventListener('click', async function (event) {
      const block = getBlock();
      if (!block) return;
      if (!isAppleEnv()) return;
      if (block.getAttribute('data-has-real-apple') === 'true') return;

      event.preventDefault();
      event.stopPropagation();

      if (trigger.dataset.lbBusy === 'true') return;
      trigger.dataset.lbBusy = 'true';

      try {
        const added = await addCurrentProductToCart();

        if (added) {
          document.dispatchEvent(new CustomEvent('cart:add'));
        } else if (typeof window.lbOpenCartDrawer === 'function') {
          window.lbOpenCartDrawer();
        }
      } catch (error) {
        console.error('Fake Apple button add-to-cart error:', error);
        if (typeof window.lbOpenCartDrawer === 'function') {
          window.lbOpenCartDrawer();
        }
      } finally {
        trigger.dataset.lbBusy = 'false';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindSizeSelection();
    bindAppleDrawerOpen();
  });

  document.addEventListener('shopify:section:load', function () {
    bindSizeSelection();
    bindAppleDrawerOpen();
  });
})();